module.exports = __webpack_public_path__ + "static/media/light-orange-dot.e2b6a8cb.svg";